import { ALERT_STYLE, nwsSeverityColor } from '../config/alerts';
import { formatDateTime, parseISODate } from '../lib/format';
import type { Alert } from '../types/alerts';
import { Card, Pill } from './ui';

/** FloodWarningDetailView: event header, pills, sender and expiry, headline, Description and What To Do cards. */
export function AlertDetail({ alert }: { alert: Alert }) {
  const color = ALERT_STYLE[alert.kind].color;
  const expires = parseISODate(alert.expires);
  return (
    <article className="alert-detail">
      <header className="alert-detail-header">
        <h2 className="alert-detail-event" style={{ color }}>
          <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3L22 21H2L12 3z" fill="currentColor" />
            <path d="M12 9v5M12 17.5v.5" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
          </svg>
          {alert.event}
        </h2>
        <p className="alert-detail-area">{alert.areaDesc}</p>
      </header>
      <hr className="divider" />
      <div className="pill-row" aria-label="Severity, urgency and certainty">
        <Pill color={nwsSeverityColor(alert.severity)}>{alert.severity}</Pill>
        <Pill color="#8e8e93">{alert.urgency}</Pill>
        <Pill color="#8e8e93">{alert.certainty}</Pill>
      </div>
      <div className="alert-detail-meta">
        <div>
          <span aria-hidden="true">📡 </span>
          {alert.senderName}
        </div>
        {expires ? (
          <div>
            <span aria-hidden="true">🕒 </span>
            Expires {formatDateTime(expires)}
          </div>
        ) : null}
      </div>
      <hr className="divider" />
      {alert.headline && alert.headline !== alert.event ? <p className="alert-detail-headline">{alert.headline}</p> : null}
      <Card title="Description">
        <p className="prewrap">{alert.description || 'No description was provided.'}</p>
      </Card>
      {alert.instruction && alert.instruction.trim() !== '' ? (
        <Card title="What To Do">
          <p className="prewrap">{alert.instruction}</p>
        </Card>
      ) : null}
    </article>
  );
}
